export function afterHook(event: string, context: string): string {
  return `runAfterHooks('${event}', ${context})`
}
